import type { EmployeeProfileResponseDTO } from "@/modules/users/domain/contracts/employee-profile";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export const dashboardApi = {
  getEmployeeProfile: () =>
    fetcher.get<EmployeeProfileResponseDTO>(`${config.apiUrl}/me/profile`),
};
